import { useMemo } from 'react';
import { AnimatePresence } from 'motion/react';

import { useCarousel } from './hooks/useCarousel';
import { useGetParams } from './hooks/useGetParams';

import MessagesList from './components/MessagesList/MessagesList';
import defaultBackground from './assets/images/bg.png';

function App() {
  const {
    currentState,
    isVisible,
    showedMessages,
    setDelay,
    currentMessageRef,
  } = useCarousel();

  const { bg, bgColor, authorFontSize, msgFontSize } = useGetParams();

  const background = useMemo(() => {
    return bg && bg !== '0'
      ? `url(${
          bg === '1' ? defaultBackground : bg
        }) center/cover no-repeat, ${bgColor}`
      : `none, ${bgColor}`;
  }, [bg]);

  return (
    <div className="app-wrapper" style={{ background }}>
      <AnimatePresence mode="wait">
        {currentState === 'S1' && (
          <MessagesList
            key={currentState}
            messages={showedMessages}
            setDelay={setDelay}
            currentMessageRef={currentMessageRef}
            authorFontSize={authorFontSize}
            msgFontSize={msgFontSize}
          />
        )}
      </AnimatePresence>

      <div id="img-loader"></div>
    </div>
  );
}

export default App;
